<template>
  <ContainerWithErrorMessage
    is="v-btn-group"
    :error-message="errorMessage"
    class="d-flex align-center my-4 ga-4"
  >
    <v-text-field
      ref="input"
      v-model="context.value.value[props.field.key]"
      :label="$t(props.field.properties.label)"
      :step="step"
      :min="minValue"
      :max="maxValue"
      :hide-details="true"
      type="number"
      @update:model-value="onInput"
    />
    <v-btn-group divided>
      <v-btn class="preset-button" variant="outlined" @click="setAngle(0)"
        >0°</v-btn
      >
      <v-btn class="preset-button" variant="outlined" @click="setAngle(90)"
        >90°</v-btn
      >
      <v-btn class="preset-button" variant="outlined" @click="setAngle(180)">
        180°
      </v-btn>
      <v-btn class="preset-button" variant="outlined" @click="setAngle(270)">
        270°
      </v-btn>
    </v-btn-group>
  </ContainerWithErrorMessage>
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'
import { computed, onMounted, ref } from 'vue'

import ContainerWithErrorMessage from '@/components/common/ContainerWithErrorMessage.vue'

import type { SchemaFormKitProps } from './types'

const context = useFormKitContext()

const errorMessage = ref<string | null>(null)
const props = defineProps<SchemaFormKitProps>()

const input = ref(null)
const step = computed(() => {
  return props.field.properties.step
})

const minValue = computed(() => {
  return props.field.properties.min
})

const maxValue = computed(() => {
  return props.field.properties.max
})

function checkValid(value) {
  if (maxValue.value && value > maxValue.value) {
    errorMessage.value = `Max Value is ${maxValue.value}`
  } else if (minValue.value && value < minValue.value) {
    errorMessage.value = `Min Value is ${minValue.value}`
  }
}

onMounted(() => {
  checkValid(context.value.value.value[props.field.key])
  input.value.checkHtml5Validity()
})

function onInput(value) {
  value = parseInt(value)
  context.value.value.value[props.field.key] = value
  checkValid(value)
}

function setAngle(value: number) {
  context.value.value.value[props.field.key] = value
}
</script>

<style lang="scss" scoped>
.preset-button {
  width: 50px;
}
</style>
